<script setup lang="ts">
import type { ICellRendererParams } from "ag-grid-community";
import LucideIcon from "../../components/icons/LucideIcon.vue";
import type { SuggestedOrdersDemoRow } from "./suggestedOrdersDemo.ts";

defineProps<{ params: ICellRendererParams<SuggestedOrdersDemoRow> }>();
</script>

<template>
  <button
    type="button"
    class="suggested-orders-flow-placeholder"
    disabled
    :aria-label="`Flow for SKU ${params.data?.sku ?? ''} (link not available yet)`"
    title="Flow link not available yet"
  >
    <LucideIcon name="external-link" :size="16" />
  </button>
</template>
